import { g as y, f as _ } from "./format._HymmFPq.js";
function S() {
  return Object.assign({}, y());
}
function w(e, t, n) {
  const r = S(), i = X(e, n.timeZone, n.locale ?? r.locale);
  return "formatToParts" in i ? E(i, t) : L(i, t);
}
function E(e, t) {
  const n = e.formatToParts(t);
  for (let r = n.length - 1; r >= 0; --r)
    if (n[r].type === "timeZoneName")
      return n[r].value;
}
function L(e, t) {
  const n = e.format(t).replace(/\u200E/g, ""), r = / [\w-+ ]+$/.exec(n);
  return r ? r[0].substr(1) : "";
}
function X(e, t, n) {
  return new Intl.DateTimeFormat(n ? [n.code, "en-US"] : void 0, {
    timeZone: t,
    timeZoneName: e
  });
}
function A(e, t) {
  const n = k(t);
  return "formatToParts" in n ? W(n, e) : v(n, e);
}
const P = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function W(e, t) {
  try {
    const n = e.formatToParts(t), r = [];
    for (let i = 0; i < n.length; i++) {
      const a = P[n[i].type];
      a !== void 0 && (r[a] = parseInt(n[i].value, 10));
    }
    return r;
  } catch (n) {
    if (n instanceof RangeError)
      return [NaN];
    throw n;
  }
}
function v(e, t) {
  const n = e.format(t), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
  return [
    parseInt(r[3], 10),
    parseInt(r[1], 10),
    parseInt(r[2], 10),
    parseInt(r[4], 10),
    parseInt(r[5], 10),
    parseInt(r[6], 10)
  ];
}
const D = {}, Y = new Intl.DateTimeFormat("en-US", {
  hourCycle: "h23",
  timeZone: "America/New_York",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), j = Y === "06/25/2014, 00:00:00" || Y === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
function k(e) {
  return D[e] || (D[e] = j ? new Intl.DateTimeFormat("en-US", {
    hourCycle: "h23",
    timeZone: e,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }) : new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  })), D[e];
}
function F(e, t, n, r, i, a, s) {
  const o = /* @__PURE__ */ new Date(0);
  return o.setUTCFullYear(e, t, n), o.setUTCHours(r, i, a, s), o;
}
const h = 36e5, R = 6e4, d = {
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function I(e, t, n) {
  if (!e)
    return 0;
  let r = d.timezoneZ.exec(e);
  if (r)
    return 0;
  let i, a;
  if (r = d.timezoneHH.exec(e), r)
    return i = parseInt(r[1], 10), M(i) ? -(i * h) : NaN;
  if (r = d.timezoneHHMM.exec(e), r) {
    i = parseInt(r[2], 10);
    const s = parseInt(r[3], 10);
    return M(i, s) ? (a = Math.abs(i) * h + s * R, r[1] === "+" ? -a : a) : NaN;
  }
  if (B(e)) {
    t = new Date(t || Date.now());
    const s = n ? t : G(t), o = p(s, e);
    return -(n ? o : q(t, o, e));
  }
  return NaN;
}
function G(e) {
  return F(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds());
}
function p(e, t) {
  const n = A(e, t), r = F(n[0], n[1] - 1, n[2], n[3] % 24, n[4], n[5], 0).getTime();
  let i = e.getTime();
  const a = i % 1e3;
  return i -= a >= 0 ? a : 1e3 + a, r - i;
}
function q(e, t, n) {
  let i = e.getTime() - t;
  const a = p(new Date(i), n);
  if (t === a)
    return t;
  i -= a - t;
  const s = p(new Date(i), n);
  return a === s ? a : Math.max(a, s);
}
function M(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
const O = {};
function B(e) {
  if (O[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), O[e] = !0, !0;
  } catch {
    return !1;
  }
}
const J = 60 * 1e3, Q = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = T(n.timeZone, e);
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return x(r);
      case "XXXX":
      case "XX":
        return l(r);
      case "XXXXX":
      case "XXX":
      default:
        return l(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = T(n.timeZone, e);
    switch (t) {
      case "x":
        return x(r);
      case "xxxx":
      case "xx":
        return l(r);
      case "xxxxx":
      case "xxx":
      default:
        return l(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = T(n.timeZone, e);
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + V(r, ":");
      case "OOOO":
      default:
        return "GMT" + l(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return w("short", e, n);
      case "zzzz":
      default:
        return w("long", e, n);
    }
  }
};
function T(e, t) {
  const n = e ? I(e, t, !0) / J : t?.getTimezoneOffset() ?? 0;
  if (Number.isNaN(n))
    throw new RangeError("Invalid time zone specified: " + e);
  return n;
}
function m(e, t) {
  const n = e < 0 ? "-" : "";
  let r = Math.abs(e).toString();
  for (; r.length < t; )
    r = "0" + r;
  return n + r;
}
function l(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), i = m(Math.floor(r / 60), 2), a = m(Math.floor(r % 60), 2);
  return n + i + t + a;
}
function x(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + m(Math.abs(e) / 60, 2) : l(e, t);
}
function V(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.floor(r / 60), a = r % 60;
  return a === 0 ? n + String(i) : n + String(i) + t + m(a, 2);
}
function z(e) {
  const t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), +e - +t;
}
const K = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, N = 36e5, C = 6e4, ee = 2, u = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: K
};
function b(e, t = {}) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  const n = t.additionalDigits == null ? ee : Number(t.additionalDigits);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (Object.prototype.toString.call(e) !== "[object String]")
    return /* @__PURE__ */ new Date(NaN);
  const r = te(e), { year: i, restDateString: a } = ne(r.date, n), s = re(a, i);
  if (s === null || isNaN(s.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  if (s) {
    const o = s.getTime();
    let c = 0, f;
    if (r.time && (c = ie(r.time), c === null || isNaN(c)))
      return /* @__PURE__ */ new Date(NaN);
    if (r.timeZone || t.timeZone) {
      if (f = I(r.timeZone || t.timeZone, new Date(o + c)), isNaN(f))
        return /* @__PURE__ */ new Date(NaN);
    } else
      f = z(new Date(o + c)), f = z(new Date(o + c + f));
    return new Date(o + c + f);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function te(e) {
  const t = {};
  let n = u.dateTimePattern.exec(e), r;
  if (n ? (t.date = n[1], r = n[3]) : (n = u.datePattern.exec(e), n ? (t.date = n[1], r = n[2]) : (t.date = null, r = e)), r) {
    const i = u.timeZone.exec(r);
    i ? (t.time = r.replace(i[1], ""), t.timeZone = i[1].trim()) : t.time = r;
  }
  return t;
}
function ne(e, t) {
  if (e) {
    const n = u.YYY[t], r = u.YYYYY[t];
    let i = u.YYYY.exec(e) || r.exec(e);
    if (i) {
      const a = i[1];
      return {
        year: parseInt(a, 10),
        restDateString: e.slice(a.length)
      };
    }
    if (i = u.YY.exec(e) || n.exec(e), i) {
      const a = i[1];
      return {
        year: parseInt(a, 10) * 100,
        restDateString: e.slice(a.length)
      };
    }
  }
  return {
    year: null
  };
}
function re(e, t) {
  if (t === null)
    return null;
  let n, r, i;
  if (!e || !e.length)
    return n = /* @__PURE__ */ new Date(0), n.setUTCFullYear(t), n;
  let a = u.MM.exec(e);
  if (a)
    return n = /* @__PURE__ */ new Date(0), r = parseInt(a[1], 10) - 1, H(t, r) ? (n.setUTCFullYear(t, r), n) : /* @__PURE__ */ new Date(NaN);
  if (a = u.DDD.exec(e), a) {
    n = /* @__PURE__ */ new Date(0);
    const s = parseInt(a[1], 10);
    return oe(t, s) ? (n.setUTCFullYear(t, 0, s), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = u.MMDD.exec(e), a) {
    n = /* @__PURE__ */ new Date(0), r = parseInt(a[1], 10) - 1;
    const s = parseInt(a[2], 10);
    return H(t, r, s) ? (n.setUTCFullYear(t, r, s), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = u.Www.exec(e), a)
    return i = parseInt(a[1], 10) - 1, Z(i) ? U(t, i) : /* @__PURE__ */ new Date(NaN);
  if (a = u.WwwD.exec(e), a) {
    i = parseInt(a[1], 10) - 1;
    const s = parseInt(a[2], 10) - 1;
    return Z(i, s) ? U(t, i, s) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function ie(e) {
  let t, n, r = u.HH.exec(e);
  if (r)
    return t = parseFloat(r[1].replace(",", ".")), g(t) ? t % 24 * N : NaN;
  if (r = u.HHMM.exec(e), r)
    return t = parseInt(r[1], 10), n = parseFloat(r[2].replace(",", ".")), g(t, n) ? t % 24 * N + n * C : NaN;
  if (r = u.HHMMSS.exec(e), r) {
    t = parseInt(r[1], 10), n = parseInt(r[2], 10);
    const i = parseFloat(r[3].replace(",", "."));
    return g(t, n, i) ? t % 24 * N + n * C + i * 1e3 : NaN;
  }
  return null;
}
function U(e, t, n) {
  t = t || 0, n = n || 0;
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  const i = r.getUTCDay() || 7, a = t * 7 + n + 1 - i;
  return r.setUTCDate(r.getUTCDate() + a), r;
}
const ae = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], se = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function $(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function H(e, t, n) {
  if (t < 0 || t > 11)
    return !1;
  if (n != null) {
    if (n < 1)
      return !1;
    const r = $(e);
    if (r && n > se[t] || !r && n > ae[t])
      return !1;
  }
  return !0;
}
function oe(e, t) {
  if (t < 1)
    return !1;
  const n = $(e);
  return !(n && t > 366 || !n && t > 365);
}
function Z(e, t) {
  return !(e < 0 || e > 52 || t != null && (t < 0 || t > 6));
}
function g(e, t, n) {
  return !(e < 0 || e >= 25 || t != null && (t < 0 || t >= 60) || n != null && (n < 0 || n >= 60));
}
const ue = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function ce(e, t, n = {}) {
  t = String(t);
  const r = t.match(ue);
  if (r) {
    const i = b(n.originalDate || e, n);
    t = r.reduce(function(a, s) {
      if (s[0] === "'")
        return a;
      const o = a.indexOf(s), c = a[o - 1] === "'", f = a.replace(s, "'" + Q[s[0]](i, s, n) + "'");
      return c ? f.substring(0, o - 1) + f.substring(o + 1) : f;
    }, t);
  }
  return _(e, t, n);
}
function fe(e, t, n) {
  e = b(e, n);
  const r = I(t, e, !0), i = new Date(e.getTime() - r), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(i.getUTCFullYear(), i.getUTCMonth(), i.getUTCDate()), a.setHours(i.getUTCHours(), i.getUTCMinutes(), i.getUTCSeconds(), i.getUTCMilliseconds()), a;
}
function me(e, t, n, r) {
  return r = {
    ...r,
    timeZone: t,
    originalDate: e
  }, ce(fe(e, t, { timeZone: r.timeZone }), n, r);
}
export {
  me as f
};
//# sourceMappingURL=index.BibbCfRO.js.map
